import {
  Button,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Spinner,
} from '@fluentui/react-components';
import React, { useEffect } from 'react';
import { useStyles } from '../components/styles/DeleteDialog.styles';

export interface IDeleteDialogProps {
  showDeleteDialog: boolean;
  showDeletingSpinner: boolean;
  selectedItem: string;
  onItemsUpdated: () => void;
  deleteItem: () => void;
  closeDeleteModal: () => void;
  onDialogClosed?: () => void;
}

export const DeleteDialog: React.FunctionComponent<IDeleteDialogProps> = (
  props: IDeleteDialogProps,
) => {
  const styles = useStyles();

  // Call onDialogClosed when dialog closes, handling both ESC and clicking outside
  useEffect(() => {
    // When dialog closes (either by user action or programmatically)
    if (!props.showDeleteDialog && props.onDialogClosed) {
      // Small delay to ensure proper sequencing of events
      setTimeout(() => {
        props.onDialogClosed?.();
      }, 10);
    }
  }, [props.showDeleteDialog]);

  const handleCloseModal = () => {
    props.closeDeleteModal();
  };

  const handleDeleteItem = () => {
    props.deleteItem();
  };

  return (
    <Dialog
      open={props.showDeleteDialog}
      onOpenChange={(e, data) => {
        if (!data.open) {
          props.closeDeleteModal();
        }
      }}
    >
      <DialogSurface>
        {!props.showDeletingSpinner && (
          <DialogBody className="kt-ui-app dialog-content">
            <DialogTitle
              id="delete-dialog-title"
              data-testid="delete-dialog-title"
            >
              Delete
            </DialogTitle>
            <DialogContent>
              <p className={styles.dialogContent}>
                Are you sure you want to delete {props.selectedItem}?
              </p>
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                onClick={handleDeleteItem}
                data-testid="delete-button"
              >
                Delete
              </Button>
              <Button appearance="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
            </DialogActions>
          </DialogBody>
        )}
        {props.showDeletingSpinner && (
          <>
            <Spinner label={'Deleting ' + props.selectedItem + '...'} />
          </>
        )}
      </DialogSurface>
    </Dialog>
  );
};
